<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 15">
  <path d="M6 .5.375 14.217l.532.533L6 12.5l5.092 2.25.533-.533L6 .5Z" fill="currentColor"/>
</svg>
